module.exports = __webpack_public_path__ + "static/media/dialog-4.51786a71.png";